import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LogeadoGuard } from './Servicios/logeado.guard';
import { TabsPage } from './tabs/tabs.page';

const routes: Routes = [
  {
    path: 'alo/acceso',
    component: TabsPage,
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    
  },
  {
    path: 'tabs',
    component: TabsPage,
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    
    //canActivate: [LogeadoGuard]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
    
  }
 

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
